import { DateTime } from 'luxon'

declare const NotificationIDSymbol: unique symbol
export type NotificationID = string & { [NotificationIDSymbol]: never }

export interface NotificationDto {
    created_at?: string
    message?: string

    id: string

    type?: string,

    notifiable_id?: string,
    notifiable_type?: string,

    data?: { shift_id?: string, offer_id?: string },

    read_at?: string | null
}

export interface Notification {
    createdAt?: DateTime | null
    message?: string

    id: NotificationID

    type?: string,

    notifiable_id?: string,
    notifiable_type?: string,

    data?: { shift_id?: string, offer_id?: string },

    readAt?: DateTime | null
}

export const createNotification = (
    params: {
        createdAt?: DateTime | null
        message?: string

        id: NotificationID

        type?: string,

        notifiable_id?: string,
        notifiable_type?: string,

        data?: { shift_id?: string, offer_id?: string },

        readAt?: DateTime | null
    }
): Notification => ({
    createdAt: params.createdAt,
    message: params.message,

    id: params.id,

    type: params.type,

    notifiable_id: params.notifiable_id,
    notifiable_type: params.notifiable_type,

    data: params.data,

    readAt: params.readAt
})

export const notificationFromDto = (dto: NotificationDto): Notification => (createNotification({
    createdAt: dto.created_at ? DateTime.fromISO(dto.created_at) : null,
    message: dto.message,

    id: dto.id as NotificationID,
    type: dto.type,
    notifiable_id: dto.notifiable_id,
    notifiable_type: dto.notifiable_type,
    data: dto.data,
    readAt: dto.read_at ? DateTime.fromISO(dto.read_at) : null
}))